/************************************************************
 Inpatient Transfer Namespace
 ************************************************************/

window.inpatientTransferNS = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        // Cancel Requisition
        if (actionId == 3) {
            inpatientTransferNS.openReason(inpatientTransferNS.cancelReasonModalHandler);
        }
        // Reject
        else if(actionId == 47){
            inpatientTransferNS.openReason(inpatientTransferNS.rejectReasonModalHandler);
        }
        // Edit
        else if(actionId == 36){
            Hades.loadShortcut(50, {id: inpatientTransferNS._row.treatment_id, transfer_id: inpatientTransferNS._action.task_id, type:'inpatient_treatment'});
        }
        // Other actions
        else {
            inpatientTransferNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(inpatientTransferNS._action, inpatientTransferNS._callback, inpatientTransferNS._row);
    },
    // Open Reason
    openReason:function (callback) {
        var params = {
            task_id:inpatientTransferNS._action.task_id,
            wf_id:inpatientTransferNS._action.wf_id,
            wf_status_id:inpatientTransferNS._action.to_state_id,
            wf_action_id:inpatientTransferNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientTransferNS._callback(false, inpatientTransferNS._action, inpatientTransferNS._row);
            });
    },
    // Cancel Requisition
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:inpatientTransferNS._action.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:inpatientTransferNS._action.wf_id,
            wf_status_id:inpatientTransferNS._action.wf_status_id,
            wf_action_id:inpatientTransferNS._action.wf_action_id};

        $.post('/inpatient/transfers/cancel_inpatient_transfer_request', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    inpatientTransferNS._callback(false, inpatientTransferNS._action, inpatientTransferNS._row);
                } else {
                    inpatientTransferNS._callback(true, inpatientTransferNS._action, inpatientTransferNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientTransferNS._callback(false, inpatientTransferNS._action, inpatientTransferNS._row);
            });
    },
    // Cancel Requisition
    rejectReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:inpatientTransferNS._action.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:inpatientTransferNS._action.wf_id,
            wf_status_id:inpatientTransferNS._action.wf_status_id,
            wf_action_id:inpatientTransferNS._action.wf_action_id};

        $.post('/inpatient/transfers/reject_inpatient_transfer_request', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    inpatientTransferNS._callback(false, inpatientTransferNS._action, inpatientTransferNS._row);
                } else {
                    inpatientTransferNS._callback(true, inpatientTransferNS._action, inpatientTransferNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientTransferNS._callback(false, inpatientTransferNS._action, inpatientTransferNS._row);
            });
    }
};